module.exports = __webpack_public_path__ + "img/parkingdescribeLogo.7489be2c.png";